import script from "./MiddleMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MiddleMenu.vue?vue&type=script&setup=true&lang=js"

import "./MiddleMenu.vue?vue&type=style&index=0&id=47d48e6f&lang=css"

const __exports__ = script;

export default __exports__